module.exports = __webpack_public_path__ + "static/img/normal.c0acefb7.png";